import { useEffect, useState } from "react";
import { onSnapshot, query, where } from "firebase/firestore";
import { photoItemsCol } from "../utils/photo";

// Live list of a resident's slideshow photos (residentPhotos/{id}/items), oldest
// first. Callers pass tenantId: caregivers MUST filter by it (the rules authorize
// a caregiver list only when constrained to their tenant); a device may pass its
// resident's tenantId too — its read is authorized by the board claim regardless.
export default function useResidentPhotos(residentId, tenantId) {
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    setPhotos([]);
    if (!residentId || !tenantId) return;
    const q = query(photoItemsCol(residentId), where("tenantId", "==", tenantId));
    const unsub = onSnapshot(
      q,
      (snap) => {
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        list.sort((a, b) => (a.createdAt?.toMillis?.() || 0) - (b.createdAt?.toMillis?.() || 0));
        setPhotos(list);
      },
      (err) => console.error("resident photos subscribe failed:", err)
    );
    return unsub;
  }, [residentId, tenantId]);

  return photos;
}
